import Template from './DisplayConfigurationView.njk';
import _ from "underscore";
import Backbone from "backbone";
import Marionette from "backbone.marionette";
import { ExperienceSelectorView } from "../../components/ExperienceSelector/ExperienceSelectorView";
import { Config } from "../../../application/Config";
import { FileUploadThumbnail } from "../../components/FileUploadThumbnail";
import { ExperienceCollection } from "../../../collections/ExperienceCollection";
import "./DisplayConfigurationView.less";

export const DisplayConfigurationView = Marionette.View.extend({
  template: Template,
    className: "DisplayConfigurationView",
    regions: {
        experienceSelector: ".region-experience-selector",
        backgroundPreview: "#background-preview"
    },

    events: {
        "keyup #name": "onNameChange",
        "change [name=header-backgroundType]": "onHeaderBackgroundTypeChange",
        "change #config-header-backgroundColor": "onHeaderBackgroundColorChange",
        "change #config-header-backgroundImage": "onHeaderBackgroundImageChange",
        "change #config-header-backgroundSize": "onHeaderBackgroundSizeChange",
        "change #config-header-textColor": "onHeaderTextColorChange",
        "change #config-header-logoImage": "onHeaderLogoChange",
        "change #config-header-logoSize": "onHeaderLogoSizeChange",
        "change #config-events-showGuides": "onEventsShowGuidesChange",
        "change #config-events-capacity": "onEventsCapacityChange",
        "change #config-events-availability": "onEventsAvailabilityChange",
        "change #config-events-showTomorrowsEvents": "onEventsShowTomorrowsEventsChange",
        "change #config-events-availabilityBlink": "onEventsAvailabilityBlinkChange",
        "change #config-events-showPrice": "onEventsShowPriceChange",
        "change #config-events-showDuration": "onEventsShowDurationChange",
        "change #config-events-showDemographics": "onEventsShowDemographicsChange",
        "change #config-events-hideTimeout": "onEventsHideTimeoutChange",

        "change :radio": "onToggleRadio"
    },

    childViewEvents: {
        'experienceSelectionChanged': 'onExperienceSelectionChanged'
    },

    initialize(options) {
    },

    debounceSave: _.debounce(function(params) {
        return this.model.save(params, {
            complete: () => {
                this.$el.find(".page-header .actions .spinner").addClass("hidden");
            }
        });
    }, 1000),

    saveInBackground() {
        this.$el.find(".page-header .actions .spinner").removeClass("hidden");

        return this.debounceSave();
    },

    templateContext() {
        return {
            url: Config.baseUrl.ui + "/#?seller=" + this.model.get("seller") + "&apiKey=" + Config.user.get("apiKey") + "&display=" + this.model.id,
            logoPreviewUrl: Config.baseUrl.configuration ? Config.baseUrl.configuration + "/" + this.model.get("config").header.logoImage : this.model.get("config").header.logoImage
        }
    },

    onRender() {
        if (this.model.get("config").events.capacity == "available") {
            this.$el.find("#config-events-hideTimeout .event-dependant").attr("disabled", true);
        }

        var experienceCollection = new ExperienceCollection();
        experienceCollection.filters.seller = this.model.get("seller");
        experienceCollection.fetchRecursive(10);

        var experienceSelectorView = new ExperienceSelectorView({
            collection: experienceCollection,
            selectedExperiences: this.model.get("config").events.listings
        });
        this.showChildView("experienceSelector", experienceSelectorView);

        var backgroundThumbnail = new FileUploadThumbnail({
            model: new Backbone.Model({image: this.model.get("config").header.backgroundImage})
        });
        this.showChildView("backgroundPreview", backgroundThumbnail);
    },

    onToggleRadio(event) {
        var $el = $(event.target);
        var $parent = $el.closest(".radio");

        this.$el.find(".radio").removeClass("active");

        if (event.target.checked) {
            $parent.addClass("active");
        }
    },

    onHeaderBackgroundImageChange(event) {
        var formData = new FormData();
        formData.append("config-header-backgroundImage", event.target.files[0]);
        this.$el.find(".page-header .actions .spinner").removeClass("hidden");

        Backbone.$.ajax({
            url: Config.baseUrl.configuration + "/devices/" + this.model.id + "/header/backgroundImage",
            data: formData,
            type: 'POST',
            contentType: false,
            processData: false,
            beforeSend: (jqXHR, settings) => {
                if (Config.user && Config.user.has('apiKey')) {
                    jqXHR.setRequestHeader("X-USER-ID", Config.user.id);
                    jqXHR.setRequestHeader("X-API-KEY", Config.user.get('apiKey'));
                    jqXHR.setRequestHeader("X-SELLER-ID", Config.seller.id);
                }
            },
            success: (data) => {
                this.$el.find("#config-header-backgroundImage").val(null);
                this.model.get("config").header.backgroundImage = data;

                var backgroundThumbnail = new FileUploadThumbnail({
                    model: new Backbone.Model({image: this.model.get("config").header.backgroundImage})
                });
                this.showChildView("backgroundPreview", backgroundThumbnail);
                this.$el.find(".page-header .actions .spinner").addClass("hidden");
            }
        });
    },

    onHeaderLogoChange(event) {
        var formData = new FormData();
        formData.append("config-header-logoImage", event.target.files[0]);
        this.$el.find(".page-header .actions .spinner").removeClass("hidden");

        Backbone.$.ajax({
            url: Config.baseUrl.configuration + "/devices/" + this.model.id + "/header/logoImage",
            data: formData,
            type: 'POST',
            contentType: false,
            processData: false,
            beforeSend: (jqXHR, settings) => {
                if (Config.user && Config.user.has('apiKey')) {
                    jqXHR.setRequestHeader("X-USER-ID", Config.user.id);
                    jqXHR.setRequestHeader("X-API-KEY", Config.user.get('apiKey'));
                    jqXHR.setRequestHeader("X-SELLER-ID", Config.seller.id);
                }
            },
            success: (data) => {
                this.$el.find("#config-header-logoImage").val(null);
                this.model.get("config").header.logoImage = data;
                var templateContext = this.templateContext();
                var dateTime = new Date();
                this.$el.find("#logo-preview img").attr("src", templateContext.logoPreviewUrl + "?timestamp=" + dateTime.getTime());
                this.$el.find(".page-header .actions .spinner").addClass("hidden");
            }
        });
    },

    onNameChange(event) {
        this.model.set("name", event.target.value);
        this.saveInBackground();
    },

    onHeaderBackgroundTypeChange(event) {
        var config = this.model.get("config");
        config.header.backgroundType = event.target.value;
        this.saveInBackground();
    },

    onHeaderBackgroundColorChange(event) {
        var config = this.model.get("config");
        config.header.backgroundColor = event.target.value;
        this.saveInBackground();
    },

    onHeaderBackgroundSizeChange(event) {
        var config = this.model.get("config");
        config.header.backgroundSize = event.target.value;
        this.saveInBackground();
    },

    onHeaderLogoSizeChange(event) {
        var config = this.model.get("config");
        config.header.logoSize = event.target.value;
        this.saveInBackground();
    },

    onHeaderTextColorChange(event) {
        var config = this.model.get("config");
        config.header.textColor = event.target.value;
        this.saveInBackground();
    },

    onEventsCapacityChange(event) {
        var config = this.model.get("config");

        if (event.target.value == "available") {
            this.$el.find("#config-events-hideTimeout").val("0");
            config.events.hideTimeout = 0;
            this.$el.find("#config-events-hideTimeout .event-dependant").attr("disabled", true);
        }
        else {
            this.$el.find("#config-events-hideTimeout .event-dependant").attr("disabled", false);
        }

        if (event.target.value == "reserved") {
            this.$el.find("#config-events-showDemographics").attr("disabled", false);
        }
        else {
            this.$el.find("#config-events-showDemographics").attr("checked", false);
            config.events.showDemographics = false;
            this.$el.find("#config-events-showDemographics").attr("disabled", true);
        }

        config.events.capacity = event.target.value;
        this.saveInBackground();
    },

    onEventsAvailabilityChange(event) {
        var config = this.model.get("config");
        config.events.availability = event.target.value;
        this.saveInBackground();
    },

    onEventsShowTomorrowsEventsChange(event) {
        var config = this.model.get("config");
        config.events.showTomorrowsEvents = event.target.checked;
        this.saveInBackground();
    },

    onEventsAvailabilityBlinkChange(event) {
        var config = this.model.get("config");
        config.events.availabilityBlink = event.target.checked;
        this.saveInBackground();
    },

    onEventsShowDurationChange(event) {
        var config = this.model.get("config");
        config.events.showDuration = event.target.checked;
        this.saveInBackground();
    },

    onEventsShowDemographicsChange(event) {
        var config = this.model.get("config");
        config.events.showDemographics = event.target.checked;
        this.saveInBackground();
    },

    onEventsShowGuidesChange(event) {
        var config = this.model.get("config");
        config.events.showGuides = event.target.checked;
        this.saveInBackground();
    },

    onEventsShowPriceChange(event) {
        var config = this.model.get("config");
        config.events.showPrice = event.target.checked;
        this.saveInBackground();
    },

    onEventsHideTimeoutChange(event) {
        var config = this.model.get("config");
        config.events.hideTimeout = event.target.value;
        this.saveInBackground();
    },

    onExperienceSelectionChanged(selectedExperiences) {
        var config = this.model.get("config");
        config.events.listings = selectedExperiences;

        if (config.events.listings.all) {
            config.events.listings.selected = [];
        }

        this.saveInBackground();
    }
});




// WEBPACK FOOTER //
// ./src/js/view/pages/settings/DisplayConfigurationView.js